import React from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const reviews = [
  {
    name: "Precious Oseghale",
    text: "Loved my frames so much. It really elevated the aesthetic of my bed frame.",
    date: "18 Dec",
    rating: 5,
  },
  {
    name: "Aisha Quadri",
    text: "The frames are so elegant and well-made. They make my space feel more sophisticated!",
    date: "22 Jan",
    rating: 5,
  },
  {
    name: "Tolu Adebayo",
    text: "I was amazed by the quality of the frame. It fits perfectly with my decor. Will definitely order again!",
    date: "10 Feb",
    rating: 5,
  },
  {
    name: "Emeka Uzo",
    text: "The attention to detail on the frames is impressive. It completely transformed my living room!",
    date: "5 Mar",
    rating: 5,
  },
  {
    name: "Amaka Nwosu",
    text: "So glad I found this! The frame is sturdy, stylish, and makes my wall art pop beautifully.",
    date: "15 Mar",
    rating: 5,
  },
  {
    name: "Kunle Balogun",
    text: "Great craftsmanship! The frame enhances my artwork, making it the centerpiece of my space.",
    date: "8 Dec",
    rating: 5,
  },
  {
    name: "Fatima Bello",
    text: "I love how sleek and modern my frame looks. It’s exactly what I needed to complete my decor!",
    date: "20 Feb",
    rating: 5,
  },
  {
    name: "Treasure",
    text: "Can't get enough of my new space. I love love love it!",
    date: "25 Jan",
    rating: 5,
  },
];



const Reviews = () => {
  return (
    <div className="bg-grey text-white py-10 px-5">
      <h2 className="text-center text-2xl font-semibold mb-4">Reviews</h2>
      <p className="text-center text-gray-400 mb-6">
        Hear what our beloved customers say about us
      </p>

      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 3000 }}
        loop
        slidesPerView={1}
        spaceBetween={20}
        className="w-full max-w-2xl mx-auto"
      >
        {reviews.map((review, index) => (
          <SwiperSlide key={index}>
            <div className="bg-grey text-white p-6 rounded-xl  mx-7 text-center">
              <h3 className="font-semibold">{review.name}</h3>
              <p className="text-sm text-gray-600">{review.date}</p>
              <p className="my-3">{review.text}</p>
              <div className="flex justify-center">
                {Array.from({ length: 5 }).map((_, i) =>
                  i < review.rating ? (
                    <FaStar key={i} className="text-yellow-400 text-lg" />
                  ) : (
                    <FaRegStar key={i} className="text-gray-400 text-lg" />
                  )
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Reviews;
